export const NEW_LINE = "\n";
export const TAB_SPACE = "  ";
